import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Tipo genérico para almacenar estados de cualquier página
export interface PageState {
  [key: string]: any;
}

// Interfaz para el estado del slice
interface PageStatesState {
  // Organizar por rutas para facilitar la búsqueda
  [routePath: string]: PageState;
}

const initialState: PageStatesState = {};

const pageStatesSlice = createSlice({
  name: 'pageStates',
  initialState,
  reducers: {
    // Guarda el estado de una página específica
    savePageState: (
      state,
      action: PayloadAction<{
        path: string;
        state: PageState;
      }>,
    ) => {
      const { path, state: pageState } = action.payload;
      state[path] = {
        ...state[path],
        ...pageState,
      };
    },

    // Elimina el estado de una página específica
    clearPageState: (state, action: PayloadAction<{ path: string }>) => {
      const { path } = action.payload;
      if (state[path]) {
        delete state[path];
      }
    },

    // Elimina los estados de todas las páginas
    clearAllPageStates: (state) => {
      Object.keys(state).forEach((key) => {
        delete state[key];
      });
    },
  },
});

// Exportar acciones
export const { savePageState, clearPageState, clearAllPageStates } = pageStatesSlice.actions;

// Selector para obtener el estado de una página específica
export const selectPageState = (path: string) => (state: RootState) => state.pageStates[path] || {};

export default pageStatesSlice.reducer;
